// CustomScrollbar.tsx
import React, { FC, ReactNode } from "react";
import "./CustomScrollbar.css"; // Import custom styles for scrollbar

interface ScrollbarProps {
  children: ReactNode;
  height?: string; // Optional, default to undefined
}

const CustomScrollbar: FC<ScrollbarProps> = ({ children, height = "100%" }) => {
  return (
    <div
      className="custom-scrollbar"
      style={{ maxHeight: height, overflowY: "scroll" }}
    >
      {children}
    </div>
  );
};

export default CustomScrollbar;
